/* Panda Food 2.0, "added to your basket" confirmation.

   Two ways out on purpose: checkout for anyone who is done, and keep shopping,
   which closes and leaves them where they were. Nothing auto-dismisses,
   because a popup that vanishes on its own is one that gets missed.

   The Buy 2 Get 1 Free line is counted from the REAL cart, and only from lines
   the offer actually applies to. Bundles are already priced as three-for-two
   and boxers sit outside it, so neither counts toward the meter.              */
(function () {
  var TIER = 3;

  /* Mirrors the Buy X Get Y discount's scope. Anything outside it must not
     move the meter, or the popup promises a discount that never lands. */
  function counts(line) {
    var type = (line.product_type || '').toLowerCase();
    var title = (line.product_title || '').toLowerCase();
    if (type.indexOf('underwear') > -1 || title.indexOf('boxer') > -1) return false;
    if (title.indexOf('bundle') > -1 || title.indexOf('trio') > -1 ||
        title.indexOf('every step') > -1) return false;
    return true;
  }

  function meter(cart) {
    var n = 0;
    (cart.items || []).forEach(function (l) { if (counts(l)) n += l.quantity || 0 });
    return {
      count: n,
      free: Math.floor(n / TIER),
      needed: n === 0 ? TIER : (n % TIER === 0 ? 0 : TIER - (n % TIER))
    };
  }

  var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
  var GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/><path d="M12 7S9 2 6.5 4 8 7 12 7zM12 7s3-5 5.5-3S16 7 12 7z"/></svg>';

  var CSS =
  '.pf2-added{position:fixed;inset:0;z-index:200;display:none;align-items:center;justify-content:center;padding:20px}' +
  '.pf2-added.on{display:flex}' +
  '.pf2-added-veil{position:absolute;inset:0;background:rgba(12,50,33,.55);opacity:0;transition:opacity .3s ease}' +
  '.pf2-added.in .pf2-added-veil{opacity:1}' +
  '.pf2-added-card{position:relative;z-index:1;background:#fff;border-radius:var(--radius-md);box-shadow:var(--shadow-lg);' +
    'width:min(420px,100%);padding:24px;text-align:center;transform:translateY(14px) scale(.97);opacity:0;' +
    'transition:transform .38s cubic-bezier(.33,.78,.36,1),opacity .28s ease}' +
  '.pf2-added.in .pf2-added-card{transform:none;opacity:1}' +
  '.pf2-added-tick{width:44px;height:44px;border-radius:50%;background:var(--green-100);color:var(--green-700);' +
    'display:grid;place-items:center;margin:0 auto 12px}' +
  '.pf2-added-tick svg{width:24px;height:24px}' +
  '.pf2-added h3{font-family:"Baloo 2",sans-serif;font-weight:800;font-size:1.02rem;margin:0 0 16px;color:var(--ink)}' +
  '.pf2-added-line{display:flex;align-items:center;gap:12px;text-align:left;background:var(--cream);' +
    'border-radius:var(--radius-sm);padding:10px;margin-bottom:14px}' +
  '.pf2-added-line img{width:56px;height:56px;border-radius:var(--radius-sm);object-fit:contain;background:#fff;flex:0 0 auto}' +
  '.pf2-added-line .t{min-width:0}' +
  '.pf2-added-line b{display:block;font-family:"Baloo 2",sans-serif;font-size:.98rem;color:var(--ink);' +
    'overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
  '.pf2-added-line span{display:block;font-size:.84rem;color:var(--ink-70);' +
    'overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
  '.pf2-added-offer{display:flex;align-items:center;justify-content:center;gap:8px;background:var(--sun);' +
    'color:var(--ink);border-radius:100px;padding:9px 14px;margin-bottom:16px;' +
    'font-family:"Baloo 2",sans-serif;font-weight:800;font-size:.86rem;line-height:1.3}' +
  '.pf2-added-offer svg{width:15px;height:15px;flex:0 0 auto}' +
  '.pf2-added-acts{display:grid;gap:9px}' +
  '.pf2-added-acts a{display:block;background:var(--green-800);color:#fff;border-radius:100px;padding:15px 28px;' +
    'font-family:"Baloo 2",sans-serif;font-weight:800;text-decoration:none}' +
  '.pf2-added-acts a:hover{background:var(--green-700)}' +
  '.pf2-added-ghost{background:none;border:0;font-family:"Baloo 2",sans-serif;font-weight:700;font-size:.95rem;' +
    'color:var(--green-800);padding:12px;border-radius:100px;cursor:pointer;min-height:44px}' +
  '.pf2-added-ghost:hover{background:var(--green-100)}' +
  '@media(max-width:560px){.pf2-added{align-items:flex-end;padding:0}' +
    '.pf2-added-card{width:100%;border-radius:var(--radius-md) var(--radius-md) 0 0;' +
    'padding:22px 18px calc(22px + env(safe-area-inset-bottom));transform:translateY(100%)}}' +
  '@media(prefers-reduced-motion:reduce){.pf2-added-card,.pf2-added-veil{transition:none}}';

  var el = null, lastFocus = null;

  function build() {
    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);

    var d = document.createElement('div');
    d.className = 'pf2-added';
    d.setAttribute('role', 'dialog');
    d.setAttribute('aria-modal', 'true');
    d.setAttribute('aria-label', 'Added to your basket');
    var cartUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
    d.innerHTML =
      '<div class="pf2-added-veil" data-close></div>' +
      '<div class="pf2-added-card">' +
        '<div class="pf2-added-tick">' + TICK + '</div>' +
        '<h3>Added to your basket</h3>' +
        '<div class="pf2-added-line"><img alt="" data-img><div class="t"><b data-title></b><span data-variant></span></div></div>' +
        '<div class="pf2-added-offer" data-offer hidden>' + GIFT + '<span data-offer-text></span></div>' +
        '<div class="pf2-added-acts">' +
          '<a href="' + cartUrl + '">Go to checkout</a>' +
          '<button type="button" class="pf2-added-ghost" data-close>Keep shopping</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(d);

    d.addEventListener('click', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && d.classList.contains('on')) close();
    });
    return d;
  }

  function close() {
    if (!el) return;
    el.classList.remove('in');
    var done = function () { el.classList.remove('on'); document.body.style.overflow = '' };
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) done();
    else setTimeout(done, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* item: {name, variant, img, qty, cart} */
  window.PF2_ADDED = function (item) {
    if (!el) el = build();
    lastFocus = document.activeElement;

    el.querySelector('[data-title]').textContent = item.name || '';
    var q = item.qty || 1;
    el.querySelector('[data-variant]').textContent =
      (item.variant || '') + (q > 1 ? '  ·  Qty ' + q : '');
    var img = el.querySelector('[data-img]');
    if (item.img) { img.src = item.img; img.alt = item.name || ''; img.style.display = '' }
    else img.style.display = 'none';

    var offer = el.querySelector('[data-offer]');
    if (item.cart) {
      var m = meter(item.cart);
      if (m.count === 0) { offer.hidden = true }
      else {
        var txt;
        if (m.needed === 0) txt = m.free > 1 ? (m.free + ' free packs unlocked') : 'Free pack unlocked, taken off at checkout';
        else if (m.needed === 1) txt = 'Add 1 more pack and your cheapest is free';
        else txt = 'Add ' + m.needed + ' more packs and your cheapest is free';
        el.querySelector('[data-offer-text]').textContent = txt;
        offer.hidden = false;
      }
    } else offer.hidden = true;

    el.classList.add('on');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('in') }) });
    setTimeout(function () { el.classList.add('in') }, 40);

    var first = el.querySelector('.pf2-added-acts a');
    if (first && first.focus) first.focus();
  };

  window.PF2_ADDED_CLOSE = close;
})();
